import Chevron from "./chevron.svg";
import { ButtonProps, ButtonStyled, ButtonWrapper } from "./Referals.styled";

interface ReferalsButtonProps extends ButtonProps {
  onClick: () => void;
}

export const ReferalsButton = ({
  onClick,
  ...buttonProps
}: ReferalsButtonProps) => {
  return (
    <ButtonWrapper>
      <ButtonStyled onClick={onClick} {...buttonProps}>
        <Chevron />
      </ButtonStyled>
    </ButtonWrapper>
  );
};
